import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { Pages } from '@shared/constants';

import { DataService } from '../services/data.service';

export const bisPageGuard: CanMatchFn = () => {
  const router: Router = inject(Router);

  const dataService = inject(DataService);
  if (!dataService.environment().hasBisPage) {
    return router.parseUrl(Pages.CURRENT);
  }

  return true;
};
